import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ParentSections.css';

const ParentSectionNotifications = () => {
  const { t } = useTranslation('parent');
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'progress',
      title: 'Emma completed a course',
      message: 'Emma Smith has completed "English Basics" course',
      time: '2 hours ago',
      read: false,
      child: 'Emma Smith'
    },
    {
      id: 2,
      type: 'achievement',
      title: 'New achievement unlocked',
      message: 'James Smith has unlocked the "100 Words Learned" achievement',
      time: '1 day ago',
      read: false,
      child: 'James Smith'
    },
    {
      id: 3,
      type: 'reminder',
      title: 'Weekly report available',
      message: 'Weekly progress report for Emma Smith is now available',
      time: '2 days ago',
      read: true,
      child: 'Emma Smith'
    },
    {
      id: 4,
      type: 'alert',
      title: 'Time limit reached',
      message: 'James Smith has reached the daily time limit',
      time: '3 days ago',
      read: true,
      child: 'James Smith'
    }
  ]);

  const markAsRead = (id) => {
    setNotifications(notifications.map(n => 
      n.id === id ? { ...n, read: true } : n
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({ ...n, read: true })));
  };

  const deleteNotification = (id) => {
    setNotifications(notifications.filter(n => n.id !== id));
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'progress': return 'trending_up';
      case 'achievement': return 'emoji_events';
      case 'reminder': return 'notifications';
      case 'alert': return 'warning';
      default: return 'info';
    }
  };

  return (
    <div className="parent-main-content">
      <div className="parent-content-header">
        <div>
          <h1 className="parent-content-title">{t('notifications.title')}</h1>
          <p className="parent-content-subtitle">{t('notifications.subtitle')}</p>
        </div>
        {unreadCount > 0 && (
          <button className="parent-btn secondary" onClick={markAllAsRead}>
            <i className="material-icons">done_all</i>
            {t('notifications.markAllRead')}
          </button>
        )}
      </div>

      {/* Notification Stats */}
      <div className="parent-stats-grid">
        <div className="parent-stat-card">
          <div className="parent-stat-icon">
            <i className="material-icons">notifications</i>
          </div>
          <div className="parent-stat-content">
            <h3 className="parent-stat-value">{notifications.length}</h3>
            <p className="parent-stat-label">{t('notifications.total')}</p>
          </div>
        </div>
        <div className="parent-stat-card">
          <div className="parent-stat-icon">
            <i className="material-icons">notifications_active</i>
          </div>
          <div className="parent-stat-content">
            <h3 className="parent-stat-value">{unreadCount}</h3>
            <p className="parent-stat-label">{t('notifications.unread')}</p>
          </div>
        </div>
      </div>

      {/* Notifications List */}
      <div className="parent-section">
        {notifications.length === 0 ? (
          <div className="parent-empty-state">
            <i className="material-icons">notifications_none</i>
            <p>{t('notifications.noNotifications')}</p>
          </div>
        ) : (
          <div className="parent-notifications-list">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className={`parent-notification-item ${!notification.read ? 'unread' : ''}`}
              >
                <div className="parent-notification-icon">
                  <i className="material-icons">{getNotificationIcon(notification.type)}</i>
                </div>
                <div className="parent-notification-content">
                  <div className="parent-notification-header">
                    <h3 className="parent-notification-title">{notification.title}</h3>
                    {!notification.read && (
                      <span className="parent-notification-badge">{t('notifications.new')}</span>
                    )}
                  </div>
                  <p className="parent-notification-message">{notification.message}</p>
                  <div className="parent-notification-footer">
                    <span className="parent-notification-child">{notification.child}</span>
                    <span className="parent-notification-time">{notification.time}</span>
                  </div>
                </div>
                <div className="parent-notification-actions">
                  {!notification.read && (
                    <button
                      className="parent-btn-icon"
                      onClick={() => markAsRead(notification.id)}
                      title={t('notifications.markAsRead')}
                    >
                      <i className="material-icons">check</i>
                    </button>
                  )}
                  <button
                    className="parent-btn-icon"
                    onClick={() => deleteNotification(notification.id)}
                    title={t('notifications.delete')}
                  >
                    <i className="material-icons">delete</i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentSectionNotifications;









